import React, { useState, useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import { Carousel } from "react-responsive-carousel";
import "../../assets/css/hire.css";
import axios from "axios";
import { IonPage } from "@ionic/react";

const EMPTY_FORM = {
	firstName: "",
	lastName: "",
	emailId: "",
	number: "",
	org: "",
};

const Hire = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);
	const [formData, setFormData] = useState(EMPTY_FORM);
	const [submitting, setSubmitting] = useState(false);
	// { type: "success" | "error", text } — shown under the submit button.
	const [status, setStatus] = useState(null);

	const handleFormSubmit = async (e) => {
		e.preventDefault();
		if (submitting) return;

		if (!formData.firstName.trim() || !formData.emailId.trim()) {
			setStatus({
				type: "error",
				text: "Please enter at least your first name and email address.",
			});
			return;
		}

		setSubmitting(true);
		setStatus(null);
		try {
			const res = await axios.post("/mail/contact", formData);
			setStatus({
				type: "success",
				text:
					res.data?.message ||
					"Thanks! We've received your enquiry and will be in touch shortly.",
			});
			setFormData(EMPTY_FORM);
		} catch (err) {
			setStatus({
				type: "error",
				text:
					err.response?.data?.message ||
					"Something went wrong. Please try again, or write to business@wyden.in.",
			});
		} finally {
			setSubmitting(false);
		}
	};

	const handleChange = (e) => {
		setFormData((prevstate) => {
			return {
				...prevstate,
				[e.target.name]: e.target.value,
			};
		});
	};

	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);

	return (
		<IonPage>
			{" "}
			<div id="header_place">
				<Header isOpaque={isOpaque} />
			</div>
			<section id="hero_area6">
				<div className="center_wrapper">
					<div id="hero_area_details">
						<h1>Transform your workforce with the skills of tomorrow.</h1>
						<p>
							Delivered 100% online, our curated short courses focus on
							upskilling your employees, regardless of their location, on a
							broad scope of topics and industry skills. All learning is focused
							on the core skills and knowledge that the nation's frontline
							production and material handling workers need.{" "}
						</p>
					</div>
					<div className="card form_card">
						<p className="form_card_heading">
							Get in touch with us for custom learning solutions
						</p>
						<form onSubmit={handleFormSubmit} noValidate>
							<input
								onChange={handleChange}
								value={formData.firstName}
								className="form_input"
								type="text"
								placeholder="First Name"
								name="firstName"
								autoComplete="given-name"
								required
							/>
							<input
								onChange={handleChange}
								value={formData.lastName}
								className="form_input"
								type="text"
								placeholder="Last Name"
								name="lastName"
								autoComplete="family-name"
							/>
							<input
								onChange={handleChange}
								value={formData.emailId}
								className="form_input"
								type="email"
								placeholder="Email Id"
								name="emailId"
								autoComplete="email"
								required
							/>
							<input
								className="form_input"
								type="tel"
								placeholder="Phone Number"
								name="number"
								autoComplete="tel"
								value={formData.number}
								onChange={handleChange}
							/>
							<input
								className="form_input"
								type="text"
								placeholder="Organisation Name"
								name="org"
								autoComplete="organization"
								value={formData.org}
								onChange={handleChange}
							/>
							<button
								type="submit"
								className="submit form-submit"
								disabled={submitting}
							>
								{submitting ? "Sending..." : "Submit"}
							</button>
							{status && (
								<p
									className={`form_status form_status_${status.type}`}
									role="status"
								>
									{status.text}
								</p>
							)}
						</form>
						<p className="contact_line">
							Or Contact: <span>business@wyden.in</span>
						</p>
					</div>
				</div>
			</section>
			<section id="partners2">
				<div className="center_wrapper">
					<h2 style={{ textAlign: "center" }}>Our partners</h2>
					<div className="partner_logos">
						<div>
							<img src={`${process.env.PUBLIC_URL}/assets/fosg.png`} />
						</div>
						<div>
							<img src={`${process.env.PUBLIC_URL}/assets/saint.png`} />
						</div>
					</div>
				</div>
			</section>
			<section id="why_wyden">
				<div className="center_wrapper">
					<h2>Why Wyden for Business?</h2>
					<div id="process_cards">
						<div>
							<div className="title_no">01</div>
							<img src="" className="card_icon" />
							<div className="card_title">Optimize Diverse Talent</div>
							<div className="card_content">
								The multi-lingual byte-sized upskilling program at Wyden
								identifies clear paths and milestones for performance
								measurement. This methodology gives your organization insight
								into the process while also enabling the workforce to be
								multi-faceted and balanced that is today and future ready.
							</div>
						</div>
						<div>
							<div className="title_no">02</div>
							<img src="" className="card_icon" />
							<div className="card_title">Transform Your Organization</div>
							<div className="card_content">
								Focus your upskilling on the key business capabilities your
								organization needs to thrive from Manufacturing and Operations
								Management to Customer Service and Diversity and Inclusion. This
								benefits the workforce to apply new learnings to their roles and
								in turn drive real business growth.
							</div>
						</div>
						<div>
							<div className="title_no">03</div>
							<img src="" className="card_icon" />
							<div className="card_title">Close Skill Gaps</div>
							<div className="card_content">
								In an ever-changing world that includes increased adoption of
								technology and automation, minimizing skill gaps are in constant
								demand. Wyden’s customized courses improve existing employees’
								skills and abilities so they can remain competitive and agile as
								the demand for new capabilities increases.
							</div>
						</div>
					</div>
				</div>
			</section>
			<section id="testimonials">
				<div className="center_wrapper">
					<Carousel
						showIndicators={true}
						showThumbs={false}
						showStatus={false}
					>
						<div className="slide_wrapper">
							<div className="face">
								<img
									src={`${process.env.PUBLIC_URL}/assets/face.png`}
									className="testimonial_face"
								/>
							</div>
							<div className="test-comma">
								<img
									src={`${process.env.PUBLIC_URL}/assets/comma.svg`}
									className="comma"
								/>
							</div>
							<div className="test-content">
								Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
								diam nonummy nibh euismod tincidunt Lorem ipsum dolor sit amet,
								consectetuer adipiscing elit, sed diam nonummy nibh euismod
								tincidunt Lorem ipsum dolor sit.
							</div>
							<br />
							<br />
							<div className="testimonial_name">~ D and M Interiors</div>
						</div>
						<div className="slide_wrapper">
							<div className="face">
								<img
									src={`${process.env.PUBLIC_URL}/assets/face.png`}
									className="testimonial_face"
								/>
							</div>
							<div className="test-comma">
								<img
									src={`${process.env.PUBLIC_URL}/assets/comma.svg`}
									className="comma"
								/>
							</div>
							<div className="test-content">
								Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
								diam nonummy nibh euismod tincidunt Lorem ipsum dolor sit amet,
								consectetuer adipiscing elit, sed diam nonummy nibh euismod
								tincidunt Lorem ipsum dolor sit.
							</div>
							<br />
							<br />
							<div className="testimonial_name">~ D and M Interiors</div>
						</div>
						<div className="slide_wrapper">
							<div className="face">
								<img
									src={`${process.env.PUBLIC_URL}/assets/face.png`}
									className="testimonial_face"
								/>
							</div>
							<div className="test-comma">
								<img
									src={`${process.env.PUBLIC_URL}/assets/comma.svg`}
									className="comma"
								/>
							</div>
							<div className="test-content">
								Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
								diam nonummy nibh euismod tincidunt Lorem ipsum dolor sit amet,
								consectetuer adipiscing elit, sed diam nonummy nibh euismod
								tincidunt Lorem ipsum dolor sit.
							</div>
							<br />
							<br />
							<div className="testimonial_name">~ D and M Interiors</div>
						</div>
					</Carousel>
				</div>
			</section>
			<section id="partners2">
				<div className="center_wrapper">
					<h3 className="uplift-content">
						Want to uplift your workforce with skills relevant to a specific job
						or technology? Contact us today to discuss custom learning
						solutions.
					</h3>
					<button onClick={() => window.scrollTo(0, 0)} className="connect">
						Let's Connect
					</button>
				</div>
			</section>
			<div id="footer_place">
				<Footer />
			</div>
		</IonPage>
	);
};

export default Hire;
